<template>
  <Search />
</template>

<script>
import Search from '@/components/Search';
export default {
  components: {
    Search
  },
  nuxtI18n: {
    paths: {
      en: '/merch/png/'
    }
  },
  head() {
    const i18nSeo = this.$seoPlugin({ slash: true });
    return {
      link: [...i18nSeo.link]
    };
  }
};
</script>

<style></style>
